import React from "react"

import PropTypes from "prop-types"

import * as styles from "./newsletter-footer.module.scss"
import isRegion from "../../../helpers/newsletter-region"
import CopyContainer from "../../atoms/copy-container"

const NewsletterFooter = ({ section, country, city, segment }) => (
  <>
    <CopyContainer className={styles.footer} content={section._rawCredits} />
    {section.pixels.map((pixel) =>
      isRegion(pixel, country, city, segment) && pixel.pixels ? (
        <span
          className={styles.pixel}
          dangerouslySetInnerHTML={{ __html: pixel.pixels.code }}
        />
      ) : (
        ""
      )
    )}
  </>
)

export default NewsletterFooter

NewsletterFooter.propTypes = {
  section: PropTypes.object.isRequired,
  country: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  segment: PropTypes.string.isRequired,
}
